import * as Types from './types';

export const getOverridableQueryStringParameter = (parameterName: string, originalValue?: string): string | undefined => {
    const params = new URLSearchParams(location.search);
    const overridableParameter = params.get(parameterName);

    return overridableParameter || originalValue;
};

export const parseDynamicTags = (dynamicTags: Types.IRawDynamicTag[] = []): Record<string, string> =>
    dynamicTags.reduce<Record<string, string>>((out: Record<string, string>, tag: Types.IRawDynamicTag) => {
        out[`DTAG_${tag.name}`] = tag.value;

        return out;
    }, {});

export const parseSuperDomainEndpoint = (endpoint = ''): string => {
    const superDomainRegex = /\[superdomain]/;

    return superDomainRegex.test(endpoint)
        ? endpoint.replace(superDomainRegex, window.location.hostname
            .split('.')
            .slice(1)
            .join('.'))
        : endpoint;
};

/**
 * Used for Server Side rendering detection.
 */
export const isServerSideRendering = (): boolean => navigator.userAgent === 'ReactSnap';
